import { render } from "./HiChipsSelectable.vue?vue&type=template&id=5f8e7e54&scoped=true"
import script from "./HiChipsSelectable.vue?vue&type=script&lang=js"
export * from "./HiChipsSelectable.vue?vue&type=script&lang=js"

import "./HiChipsSelectable.vue?vue&type=style&index=0&id=5f8e7e54&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8e7e54"]])

export default __exports__